import React, { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import AdminLayout from '../../components/layout/AdminLayout';
import AnalyticsTab from '../../components/admin/AnalyticsTab';
import { fetchTournaments } from '../../components/admin/adminApiService';

const AdminAnalytics = () => {
  // Analytics state management
  const [analyticsTimeRange, setAnalyticsTimeRange] = useState('30d');
  const [selectedTournamentForAnalytics, setSelectedTournamentForAnalytics] = useState('all');
  const [analyticsView, setAnalyticsView] = useState('overview');

  // Fetch tournaments for analytics dropdown
  const { 
    data: tournaments, 
    isLoading: tournamentsLoading, 
    error: tournamentsError 
  } = useQuery({
    queryKey: ['admin-tournaments'],
    queryFn: fetchTournaments,
    refetchOnWindowFocus: false,
  });

  // Fetch analytics data (this would be replaced with actual analytics API)
  const { 
    data: analyticsData, 
    isLoading: analyticsLoading, 
    error: analyticsError 
  } = useQuery({
    queryKey: ['analytics', analyticsTimeRange, selectedTournamentForAnalytics],
    queryFn: async () => {
      // This would be replaced with actual analytics API call
      return {
        totalRevenue: 0,
        totalUsers: 0,
        activeTournaments: 0,
        // ... other analytics data
      };
    },
    refetchOnWindowFocus: false,
  });

  return (
    <AdminLayout>
      <div className="admin-content-wrapper">
        <div className="admin-card">
          <div className="admin-card-header">
            <div>
              <h1 className="admin-card-title">Analytics</h1>
              <p className="admin-card-subtitle">Tournament and betting analytics</p>
            </div>
          </div>

          <AnalyticsTab
            analyticsTimeRange={analyticsTimeRange}
            setAnalyticsTimeRange={setAnalyticsTimeRange}
            selectedTournamentForAnalytics={selectedTournamentForAnalytics}
            setSelectedTournamentForAnalytics={setSelectedTournamentForAnalytics}
            analyticsView={analyticsView}
            setAnalyticsView={setAnalyticsView}
            tournaments={tournaments || []}
            analyticsData={analyticsData}
            analyticsLoading={analyticsLoading}
            analyticsError={analyticsError}
          />
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminAnalytics;